import React from 'react'

const Presale = () => {
  return (
    <div>Presale</div>
  )
}

export default Presale